import { render, staticRenderFns } from "./EndorsementHistoryModal.vue?vue&type=template&id=1c38f29c"
import script from "./EndorsementHistoryModal.vue?vue&type=script&lang=js"
export * from "./EndorsementHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./EndorsementHistoryModal.vue?vue&type=style&index=0&id=1c38f29c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports